module.exports = __webpack_public_path__ + "img/military_base-gallery-6.09047552.jpg";